module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAARVBMVEUAAACfn5+Xl5eampqXl5eZmZmXl5eYmJiZmZmZmZmZmZmYmJiYmJiZmZmYmJiZmZmZmZmYmJiYmJiZmZmZmZmZmZmZmZmqiK4LAAAAFnRSTlMAECAwQFBgb3B/gJCfoL/Az9Df4O/wmUq9HwAAAMtJREFUWMPtl0sOwyAMBXH4pGkhhRS4/1Fbxey6qh+SVSlvP7NAw8LGXPtaqHVF+KV/FgGB66CB2mnYSWywbMiAoaAGYkO1igaT2OBRQw9ywwM2hI4mhRscJxVVo3xNivLQjJJGlE4zyjQryk0zSt9Qw4Qo26Qos0EN8qIoYwJ7nHwR85V56SM65hNhKSajxG/gd4xT+OaxfJpV4m3G8kHzG/zzX/Nbmb8p5yfladfNbxn5Wd38xDxVLJ9x8sh5PrruyNnmS/Hm2k97A+v+HzFVjJnJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = 296
// module chunks = 4 23